<template>
	<section class="form form__vertical" :class="{ container__booking: !modal }">
		<div class="form__heading">
			<h1 class="heading-title">{{ $t('auth.registration') }}</h1>
			<h2 class="content-default">
				{{ $t('auth.already_account') }} <a class="link" @click="loginForm">{{ $t('auth.to_login') }}</a>
			</h2>
		</div>
		<form class="form__input flex-vertical left-align" @submit.prevent="validateForm" @keydown="form.onKeydown($event)">
			<label for="name" class="label left-align">
				<b>{{ $t('fields.name') }}</b>
			</label>

			<input
				name="name"
				type="text"
				v-model="form.name"
				class="input"
				:class="{ 'is-danger': form.errors.has('name') }"
				:placeholder="$t('auth.your_name')"
			/>

			<label for="email" class="label left-align">
				<b>{{ $t('fields.email') }}</b>
			</label>

			<input
				name="email"
				type="text"
				v-model="form.email"
				class="input"
				:class="{ 'is-danger': form.errors.has('email') }"
				:placeholder="$t('auth.your_email')"
			/>

			<label for="password" class="label left-align">
				<b>{{ $t('fields.password') }}</b>
			</label>

			<input
				name="password"
				type="password"
				v-model="form.password"
				class="input"
				:class="{ 'is-danger': form.errors.has('password') }"
				:placeholder="$t('fields.password')"
			/>

			<label for="password_confirmation" class="label left-align">
				<b>{{ $t('fields.password_confirmation') }}</b>
			</label>

			<input
				name="password_confirmation"
				type="password"
				v-model="form.password_confirmation"
				class="input"
				:class="{ 'is-danger': form.errors.has('password_confirmation') }"
				:placeholder="$t('fields.password_confirmation')"
			/>

			<span class="content-default spacer_bottom-125 center-align">
				Odesláním formuláře souhlasíš s
				<a class="link" @click="terms">obchodními podmínkami</a>.
			</span>

			<v-button class="spacer_blank" :loading="form.busy">{{ $t('auth.register') }}</v-button>
		</form>
	</section>
</template>

<script>
import Form from 'vForm'
import loginMixin from '~/mixins/login.mixin.js'

export default {
	middleware: 'guest',

	mixins: [loginMixin],

	props: {
		modal: {
			type: Boolean,
			default: false,
		},
	},

	metaInfo() {
		return { title: this.$t('pages.register') }
	},

	data() {
		return {
			form: new Form({
				name: null,
				email: null,
				password: null,
				password_confirmation: null,
			}),
		}
	},

	methods: {
		loginForm() {
			this.$emit('close')
			setTimeout(() => {
				this.$modal('auth/login')
			}, 300)
		},
		terms() {
			this.$modal('components/terms')
		},
		validateForm() {
			let { name, email, password, password_confirmation } = this.form

			this.form.clear()

			if (!name) this.form.errors.set('name', this.$t('validation.field_is_required', [this.$t('fields.name')]))
			if (!email) this.form.errors.set('email', this.$t('validation.field_is_required', [this.$t('fields.email')]))
			if (!password) this.form.errors.set('password', this.$t('validation.field_is_required', [this.$t('fields.password')]))

			if (password && password !== password_confirmation)
				this.form.errors.set('password', this.$t('validation.password_confirmation_not_match'))

			if (!this.form.errors.any()) this.register()
			else this.$notifyAllErrors(this.form.errors.all())
		},
		async register() {
			try {
				let { data } = await this.form.post('/register')
				if (data) await this.login(false, this.modal)
			} catch ({ response }) {
				this.$notifyAllErrors(response.data.errors)
			}
		},
	},
}
</script>
